import SiafLiteApiRepository from "../../external/siafLiteApi";

class BancoService {
  constructor() {
    this.urlBase = "/financeiro/bancos";
    this.urlBaseEvent = `/event${this.urlBase}`;
  }

  getAll(filter) {
    return new SiafLiteApiRepository(this.urlBaseEvent).get(filter);
  }
}

export default BancoService;
